import ElementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'
import common from 'assets/themes/campings/js/page/common/index'
import { openSearchFiltersSidePanel } from 'assets/themes/campings/js/page/product/search/recap'
import type { Calendar as SearchCalendarType } from '@ui/Search/Calendar/component'

export const openCalendar = (el: HTMLElement): void => {
  const calendar = ElementPropertiesManager.getProperty<SearchCalendarType>(document.getElementById('checkInDate') as HTMLInputElement, 'calendar')

  const event = new CustomEvent('close-all-modals')
  document.body.dispatchEvent(event)

  if (el.getAttribute('data-target-anchor')) {
    document.getElementById('search-availability-form')?.setAttribute('action', el.getAttribute('data-target-anchor') as string)
  }

  const openSearchPanelEl = document.getElementById('recap-open-search')

  if ((common.isMobile() || common.isTablet()) && openSearchPanelEl) {
    openSearchFiltersSidePanel()
  } else {
    document.getElementById('booking')?.scrollIntoView({
      block: 'start',
      inline: 'nearest',
      behavior: 'smooth',
    })
    calendar?.open()
  }
}

export default function (): void {
  document.addEventListener('click', function (e) {
    const target = e.target as HTMLElement

    if (target.matches('.open-calendar')) {
      e.preventDefault()
      e.stopPropagation()

      openCalendar(target)
    }
  })
}
